import React, { useState , useEffect} from 'react';
import { connect } from 'react-redux';

import { Row, Col, Card, Container, ListGroup, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Spin, Progress } from 'antd';
import { setUploadFile } from '../../../actions/scenarioVariationUpload/uploadFile';

import UploadProgress from './uploadProgress/uploadProgress';
import {variationGeneration, cleanData} from '../../UserFunctions';
import {Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap"
import PropTypes from 'prop-types';

const ScenarioVariationUpload = props => {
    const [buttonPushPopUp, setbuttonPushPopUp] = useState(false);
    const [buttonPushPopUpCleanFiles, setbuttonPushPopUpCleanFiles] = useState(false);
    const [popupNoInputFiles,setPopupNoInputFiles] = useState(false);
    const [progress,setProgress] = useState(false);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [componentStatus, setComponentStatus] = useState(false);
    const loadingTip = 'Loading...';

    const [statusInfo, setStatusInfo] = useState({
                                            totalVariationsCount:0,
                                            totalBaseScenarioVariationsGenerated:0,
                                            totalBaseScenario:0,
                                            percentageCompleted:0
                                        });

    useEffect(() => {
        const timeout = setTimeout(() => {
            variationGeneration('/create_variations').then(res => {             
                if(res.data.data !== "No_input_files"){
                    console.log(res.data.data)
                    if(res.data.data.status === "in_progress"){
                        // alert("Input files are present.Generation of scenario variations process in progress.with ")
                        setProgress(true)
                        setLoading(true)
                        let output = res.data.data
                        let percentage = 0
                        if (output.total_base_scenario !== 0){
                            percentage = parseInt(output.total_base_scenario_variations_generated/output.total_base_scenario*100)
                        }
                        setStatusInfo({
                            totalVariationsCount : output.total_variations_count,
                            totalBaseScenarioVariationsGenerated : output.total_base_scenario_variations_generated,
                            totalBaseScenario : output.total_base_scenario,
                            percentageCompleted:percentage
                        })
                        setShow(!show)
                    }
                    else if(res.data.data === "input_files_present"){
                        setShow(!show)
                        setLoading(true)
                    }
                    else if(res.data.data === "scenario_variations_generated"){
                        setLoading(false)
                        setProgress(false)
                        setStatusInfo({
                            totalVariationsCount : 0,
                            totalBaseScenarioVariationsGenerated : 0,
                            totalBaseScenario : 0,
                            percentageCompleted:0
                        })
                        alert("Generation of scenario variations process in completed.")  
                    }
                }
                else{
                    setLoading(false)
                    setProgress(false)
                    // alert("Input files are not present.")
                }   
            })
            console.log(progress)
        }, 5000)
        return () => clearInterval(timeout);
    }, [show]);

    const handleAttachFile = e => {
        e.preventDefault()
        const uploadInput = document.getElementById('close-loop-upload-files');
        console.log(uploadInput.files)
        //const fileName = uploadInput.files[0].name;
        props.setUploadFile(uploadInput.files, 'local-filesystem')
        uploadInput.value = '' // to clear the current file field
    }

    const handleCloseGenerateVariation = () => {
        setbuttonPushPopUp(false)

      }

    const handleGenerateVariation = () => {
        setbuttonPushPopUp(true)     
    }

    const handleCloseCleanFiles = () => {
        setbuttonPushPopUpCleanFiles(false)

      }

    const handleCleanFiles = () => {
        setbuttonPushPopUpCleanFiles(true)     
    }

    const handleCloseNoInputFiles= () => {
        setPopupNoInputFiles(false)
    }

    const onComponentStatus = () => {
        setComponentStatus(!componentStatus);
      };
    
    const SubmitData = () => {
        variationGeneration('/create_variations').then(res => {
                if(res.data.data !== "No_input_files"){
                    console.log(res.data.data)
                    setShow(!show)
                    setLoading(true)
                    if(res.data.data === "in_progress"){
                        alert("Generation of scenario variations process in progress.")                        
                    }
                    if(res.data.data === "scenario_variations_generated"){
                        alert("Generation of scenario variations process in completed.")  
                    }
                }
                else{
                    setPopupNoInputFiles(true)
                }
        }) 
        handleCloseGenerateVariation()
    };

    const CleanFiles = () => {
        cleanData('/clean_data').then(res => {
            if(res.data.data === "success"){
                alert("Cleaning of scenario variation done. ")
                console.log(res) 
            } 
            else{
                alert("Cleaning of the input folder failed. Please try again. ")
            }

        }) 
        setLoading(false)
        setProgress(false)
        setStatusInfo({
            totalVariationsCount : 0,
            totalBaseScenarioVariationsGenerated : 0,
            totalBaseScenario : 0,
            percentageCompleted:0
        })
        handleCloseCleanFiles()
    };

 
    return (
        <>
            <Spin spinning={loading} tip={loadingTip}>
                <Container data-test="scenarioFileUploadComponent" className="mt-5">
                    <Row>
                        <Col>
                            <Card>
                                <Card.Header className='mb-2' style={{ backgroundColor: '#757AF7' }}>
                                    <Row>
                                        <Col md={11} sm={5}>
                                            <h4 style={{ color: "#FFFFFF" }}>Upload File(s) to create Variations</h4>
                                        </Col>
                                        <Col md={1} sm={7}>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="reset-folder">
                                                        <strong>
                                                            It will do clean up of scenario
                                                            variation input folder
                                                        </strong>
                                                    </Tooltip>
                                                }
                                            >
                                                <Button
                                                    type='submit'
                                                    style={{
                                                        backgroundColor: '#FFFFFF',
                                                        color: '#757AF7'
                                                    }}
                                                    onClick = {handleCleanFiles} 
                                                    data-test = "clickComponent"
                                                >
                                                    Stop
                                                </Button>
                                            </OverlayTrigger>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    <Form onSubmit={handleAttachFile}>
                                        <Row>
                                            <Col>
                                                <Card>
                                                    <ListGroup.Item>
                                                        <Row>
                                                            <Col>
                                                                <h4>Inputs for Scenario Variation Generation:</h4>
                                                            </Col>
                                                            <Col>
                                                                <input
                                                                    type="file"
                                                                    multiple
                                                                    id="close-loop-upload-files"
                                                                    required
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                </Card>
                                            </Col>
                                        </Row>
                                        <Row className='mt-2'>
                                            <Col>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col className='text-center'>
                                                            <Button
                                                                type='submit'
                                                                style={{
                                                                    'backgroundColor': '#757AF7',
                                                                    'color': '#FFFFFF'
                                                                }}
                                                            >
                                                                Upload
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                            </Col>
                                        </Row>
                                    
                                    </Form>
                                    <Row className='mt-2'>
                                            <Col>
                                                <ListGroup.Item>
                                                    <Row>
                                                        <Col className='text-center'>
                                                            <Button
                                                                type='submit'
                                                                style={{
                                                                    'backgroundColor': '#757AF7',
                                                                    'color': '#FFFFFF'
                                                                }}
                                                                onClick = {handleGenerateVariation} 
                                                                data-test = "clickComponent"
                                                            >
                                                                Generate Variation
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </ListGroup.Item>
                                            </Col>
                                        </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Spin>
            <UploadProgress />
            {progress ? (
                    <Modal isOpen={true}>
                        <ModalHeader>
                            <Button
                                type='submit'
                                style={{
                                    backgroundColor: '#757AF7',
                                    color: '#FFFFFF'
                                }}
                                onClick = {handleCleanFiles} 
                                data-test = "clickComponent"
                            >
                                Stop 
                            </Button>
                        </ModalHeader>
                        <ModalBody>
                            <h3>Base Scenario Variation Generation</h3>
                            <Progress
                                strokeColor={{
                                from: '#757AF7',
                                to: '#B0FF44',
                                }}
                                percent={statusInfo.percentageCompleted}
                                status="active"
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                className="btn"
                                data-toggle="collapse"
                                data-target="#components-card"
                                aria-controls="components-card"
                                onClick={onComponentStatus}
                                style={{
                                    border: "0px",
                                    color: "#FFFFFF",
                                    backgroundColor: "#9296ff"
                                }}
                                >
                                <i
                                    className={
                                    componentStatus
                                        ? "fas fa-angle-double-up"
                                        : "fas fa-angle-double-down"
                                    }
                                />
                            </Button>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="collapse" id="components-card">
                                        <p style={{ margin: "0px" }}>No of Base Scenario Variations Generated : {statusInfo.totalBaseScenarioVariationsGenerated}</p>
                                        <p style={{ margin: "0px" }}>Total Number of Base Scenarios : {statusInfo.totalBaseScenario}</p>
                                        <p style={{ margin: "0px" }}>Total Generated Variations Count : {statusInfo.totalVariationsCount}</p>   
                                    </div>
                                </div>
                            </div>
                        </ModalFooter>
                    </Modal>
                ) : undefined}
            {buttonPushPopUp ? (
                    <Modal isOpen={true}>
                        <ModalHeader
                            toggle={handleCloseGenerateVariation}
                            style={{ backgroundColor: "#753DFF" }}
                        >
                        </ModalHeader>
                        <ModalBody>
                        <p>Do you want to generate the scenario variations ?</p>
                        </ModalBody>
                        <ModalFooter>
                        <Button className="btn"  style={{marginLeft: "70%"}} onClick={SubmitData}>Yes</Button>                        
                        <Button className="btn" style={{ marginRight: "40%" , backgroundColor: "red" }} onClick={handleCloseGenerateVariation}>No</Button>
                        </ModalFooter>
                    </Modal>
                ) : undefined}
                {buttonPushPopUpCleanFiles ? (
                    <Modal isOpen={true}>
                        <ModalHeader
                            toggle={handleCloseCleanFiles}
                            style={{ backgroundColor: "#753DFF" }}
                        >
                        </ModalHeader>
                        <ModalBody>
                        <p>Do you want to clean all the files ?</p>
                        </ModalBody>
                        <ModalFooter>
                        <Button className="btn"  style={{marginLeft: "70%"}} onClick={CleanFiles}>Yes</Button>                        
                        <Button className="btn" style={{ marginRight: "40%" , backgroundColor: "red" }} onClick={handleCloseCleanFiles}>No</Button>
                        </ModalFooter>
                    </Modal>
                ) : undefined}
            {popupNoInputFiles ? (
                    <Modal isOpen={true}>
                        <ModalHeader
                            toggle={handleCloseNoInputFiles}
                            style={{ backgroundColor: "#753DFF" }}
                        >
                        </ModalHeader>
                        <ModalBody>
                        <p>There are no input files.</p>
                        </ModalBody>
                        <ModalFooter>
                        <Button className="btn"  style={{marginLeft: "70%"}} onClick={handleCloseNoInputFiles}>Ok</Button>                        
                        </ModalFooter>
                    </Modal>
                ) : undefined}
        </>
    )
}

ScenarioVariationUpload.propTypes = {
    setUploadFile: PropTypes.func
  }

const mapDispatchToProps = dispatch => ({
    setUploadFile: (files, fileSystem, scenarioListFile, scenarioSDDFile) => dispatch(
    setUploadFile(files, fileSystem, scenarioListFile, scenarioSDDFile)),
})

export default connect(undefined, mapDispatchToProps)(ScenarioVariationUpload);